module.exports = __webpack_public_path__ + "media/images/application2/AppBookingsTalk__bottom__buttons__a--video-9b03ee1888aaed0f337d8e1bb8b97d01.svg";